import classNames from 'classnames';
import { playAudio, parsingAI } from '@/utils/audioPlay';
import { ICollectOptionListItem, IMultipleProp } from '@/utils/ctype';
import i18n from '@/locales/init';
import Check from '../../../components/Check';
import SpeechBtn from '../../../components/SpeechBtn';
import Analysis from '../../../components/Analysis';
import HtmlParser, { innerBold } from '../../../components/HtmlParser';
import style from './index.module.less';


// type 2

export default function MultipleQuestion(props: IMultipleProp) {
  const { data, groupId, currentFocus, saveAnswerHandle, type, answerMap, isAI, className, isListen, keyIndex, answerAllText, setFocusIndexHandle } = props;

  const limit = data?.list?.length || 0;

  
  const numberArr = data?.list.map((item) => item.number);
  const numberClass = numberArr.map((item: number) => `question${item}`);
  const numberJoin = data?.numbers || '';
  const {display_answer, number} = (data?.list || [])[0] || {};

  const answer = answerMap[`${groupId}_${type}_`] || [];

  const handleCheckboxChange= (event: React.FormEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    let updatedCheckedItems = [...answer];
    const len = updatedCheckedItems.length;
    if ((event.target as HTMLInputElement).checked) {
      if (len < limit) {
        updatedCheckedItems.push(value);
      } else {
        (event.target as HTMLInputElement).checked = false; // 取消当前操作
      }
    } else {
      updatedCheckedItems = updatedCheckedItems.filter(item => item !== value);
    }    
    const result = new Array(updatedCheckedItems.length).fill(null);
    result[0] ={group_id: groupId, type, answer: updatedCheckedItems};
    saveAnswerHandle(numberArr.slice(), result);
  };

  const createAIType = (item: ICollectOptionListItem) => {
    if (!isAI) {
      return;
    }

    const isCorrectAnswer = !!item.title && (display_answer || '').indexOf(item.title) > -1;
    const isSelected = answer.includes(String(item.id));

    if (isCorrectAnswer && isSelected) {
      return 'success';
    }
    if (!isCorrectAnswer && isSelected) {
      return 'fail';
    }
    if (isCorrectAnswer) {
      return 'missed';
    }
    return 'normal';
  };

  const getAIStatusText = (type?: string) => {
    switch (type) {
      case 'success':
        return i18n.t('common.dauyan_selected_correct');
      case 'fail':
        return i18n.t('common.dauyan_selected_wrong');
      case 'missed':
        return i18n.t('common.dauyan_missed_correct');
      default:
        return '';
    }
  };

  return (
    <div className={classNames(style.questionBox, className, ...numberClass)} id={`question${data.number}`}>
      <div className={style.questionContent}>
        <span className={classNames(style.questionNumber, numberArr.includes(currentFocus) ? style.active : '')} data-key={`question.question.${keyIndex}.numbers`}><HtmlParser htmlString={numberJoin}></HtmlParser></span>
        <span className={style.questionText} data-key={`question.question.${keyIndex}.collect_option.title`}><HtmlParser htmlString={innerBold(data?.collect_option?.title)}></HtmlParser></span>
        {isAI && !answer.length ? <span className={classNames(style.fail, style.answerText)} data-key={`answerAllText.${number-1}`}><HtmlParser htmlString={answerAllText[number - 1]}></HtmlParser></span> : null }
        {isAI&& isListen ? <SpeechBtn onClick={() => {playAudio((data?.list || [])[0]);}} index={number}></SpeechBtn> : null}
        {isAI ? <Analysis onClick={() => {parsingAI((data?.list || [])[0]);}}></Analysis> : null}
      </div>
      <div className={style.answerBox}>
        {(data?.collect_option?.list || []).map((item, index: number) => {
          const aiType = createAIType(item);
          const statusText = getAIStatusText(aiType);
          return (
            <div className={classNames(style.answer, aiType ? style[aiType]: '')} key={index}>
              <label data-key={`question.question.${keyIndex}.collect_option.list.${index}.content`}>
                <Check type={aiType} className={style.radio} name={`anwer${numberArr.join('-')}`} value={item.id} onChange={handleCheckboxChange} checked={answer.includes(String(item.id))}
                  onFocus={() => { if (setFocusIndexHandle) {setFocusIndexHandle(number);}}}></Check>
                <HtmlParser htmlString={item.content}></HtmlParser>
                {statusText ? <span className={classNames(style.statusText, aiType ? style[`${aiType}Text`] : '')}>{statusText}</span> : null}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );
}